import React, { useEffect, useState } from 'react';
import { Facebook, Twitter, Youtube, Instagram } from 'lucide-react';
import { fetchData, API_URL } from '../helpers/api';
import PopupManager from '../components/PopupManager';
import CookieSettings from '../components/CookieSettings';

const Footer = () => {
  const [settings, setSettings] = useState({});
  const [footerData, setFooterData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchFooterContent();
  }, []);

  const fetchFooterContent = async () => {
    try {
      setLoading(true);
      const [settingsData, footerResponse] = await Promise.all([
        fetchData('/api/setting?populate=*'),
        fetch('/api/footer.php').then(r => r.json()),
      ]);
      setSettings(settingsData);
      setFooterData(footerResponse);
    } catch (e) {
      console.error('Failed fetching data: ', e);
    } finally {
      setLoading(false);
    }
  };

  if (loading || !footerData) {
    return null;
  }

  const renderLink = (link, index) => {
    const url = link.url === '__BOOKING__' ? (settings?.defaultBookingUrl || '#') : link.url;
    return (
      <li key={index} className="mb-2">
        <a
          href={url}
          {...(link.external ? { target: '_blank', rel: 'noopener noreferrer' } : {})}
          className="text-secondary text-decoration-none hover-text-white"
        >
          {link.label}
        </a>
      </li>
    );
  };

  return (
    <footer className="bg-dark text-white pt-5 pb-3">
      <div className="container">
        <div className="row mb-5">
          {/* Logo & About */}
          <div className="col-lg-3 col-md-6 mb-4 mb-lg-0">
            <img src={API_URL + settings.logo.url} alt="Mémorial ACTe Logo" className="mb-4" style={{ width: 150 }} />
            <p className="text-muted mb-4">
              {footerData.description}
            </p>
            <div className="d-flex gap-3">
              <a href={settings?.facebook || '#'} target="_blank" className="text-secondary hover-text-white">
                <Facebook size={20} />
              </a>
              <a href={settings?.twitter || '#'} target="_blank" className="text-secondary hover-text-white">
                <Twitter size={20} />
              </a>
              <a href={settings?.youtube || '#'} target="_blank" className="text-secondary hover-text-white">
                <Youtube size={20} />
              </a>
              <a href={settings?.instagram || '#'} target="_blank" className="text-secondary hover-text-white">
                <Instagram size={20} />
              </a>
            </div>
          </div>

          {/* Liens rapides */}
          <div className="col-lg-3 col-md-6 mb-4 mb-lg-0">
            <h4 className="fs-5 fw-semibold mb-4">LIENS RAPIDES</h4>
            <ul className="list-unstyled">
              {footerData.quickLinks.map(renderLink)}
            </ul>
          </div>

          {/* Informations */}
          <div className="col-lg-3 col-md-6 mb-4 mb-lg-0">
            <h4 className="fs-5 fw-semibold mb-4">INFORMATIONS</h4>
            <ul className="list-unstyled">
              {footerData.infoLinks.map(renderLink)}
            </ul>
          </div>

          {/* Contact & Hours */}
          <div className="col-lg-3 col-md-6 mb-4 mb-lg-0">
            <h4 className="fs-5 fw-semibold mb-4">HORAIRES & CONTACT</h4>
            <div className="d-flex flex-column gap-3 text-secondary">
              <div>
                <p className="fw-medium text-white mb-1">Horaires d'ouverture</p>
                <p className="mb-0">{footerData.schedule.openDays}</p>
                <p className="mb-0">{footerData.schedule.closedDays}</p>
              </div>
              <div>
                <p className="fw-medium text-white mb-1">Adresse</p>
                <p className="mb-0">{footerData.contact.address}</p>
              </div>
              <div>
                <p className="fw-medium text-white mb-1">Contact</p>
                <p className="mb-0">{footerData.contact.phone}</p>
                <p className="mb-0">{footerData.contact.email}</p>
              </div>
            </div>
          </div>
        </div>

        <div className="border-top border-secondary pt-4 mt-4 d-flex flex-column flex-md-row justify-content-between align-items-center">
          <p className="text-secondary mb-3 mb-md-0">
            © {new Date().getFullYear()} Mémorial ACTe | Tous Droits Réservés
          </p>
          <div className="d-flex flex-wrap gap-3 align-items-center">
            {footerData.bottomLinks.map((link, index) => (
              <a key={index} href={link.url} className="text-secondary text-decoration-none small">{link.label}</a>
            ))}
            <CookieSettings />
          </div>
        </div>
      </div>
      <PopupManager fetchData={fetchData} />
    </footer>
  );
};

export default Footer;